import { render, staticRenderFns } from "./dropdown-mobile.vue?vue&type=template&id=29c83c3a&scoped=true&"
import script from "./dropdown-mobile.vue?vue&type=script&lang=ts&"
export * from "./dropdown-mobile.vue?vue&type=script&lang=ts&"
import style0 from "./dropdown-mobile.vue?vue&type=style&index=0&id=29c83c3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c83c3a",
  null
  
)

export default component.exports